export interface CmsGuestCheckout {
  guestCheckoutButtonLabel: string;
  guestCheckoutDescription: string;
  guestCheckoutTitle: string;
}
